"use client";

import { Theme } from "@/constants/theme";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface UseInvoiceStore {
  setTheme: (theme: Theme) => void;
  theme: null | Theme;
}

const useThemeStore = create(
  persist<UseInvoiceStore>(
    (set) => ({
      setTheme: (theme: Theme) => set({ theme }),
      theme: null,
    }),
    {
      name: "theme-storage",
    },
  ),
);

export default useThemeStore;
